import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Logo, Wordmark } from "@/components/Brand";
import { Button } from "@/components/ui/button";

export default function Home() {
  const navigate = useNavigate();
  const [content, setContent] = useState({
    headline: "Better coffee, made simple.",
    description:
      "Great coffee shouldn’t be complicated. BrewMate takes the guesswork out of brewing with simple, step-by-step guidance—helping you make a delicious cup, your way, every time.",
    closing: "Pick your brewer. Follow the guide. Enjoy your perfect cup.",
  });

  useEffect(() => {
    api.get("/content/home").then(({ data }) => setContent(data.value)).catch(() => {});
  }, []);

  return (
    <div className="px-5 pt-8" data-testid="home-page">
      <div className="flex flex-col items-center text-center">
        <Logo size={80} />
        <h1 className="mt-5 text-4xl sm:text-5xl">
          <Wordmark className="text-[#1F2A44]" />
        </h1>
        <p className="mt-2 text-sm text-[#1F2A44]/70">Powered by Wonderbean Coffee Co.</p>
        <p className="mt-1 text-base text-[#1F2A44]/90 font-medium">{content.headline}</p>
      </div>

      <Button
        onClick={() => navigate("/brew-guide")}
        data-testid="start-brewing-btn"
        className="mt-7 w-full h-14 rounded-full bg-[#F57C00] text-[#1F2A44] text-base font-semibold hover:bg-[#E86F00] active:scale-95 transition-all"
      >
        Start Brewing
      </Button>

      <div className="mt-6 rounded-3xl overflow-hidden border border-[#1F2A44]/15 shadow-lg shadow-black/20 aspect-[16/9]">
        <img
          src="/brewmate-hero.png"
          alt="A kitchen countertop with pour over, French press, AeroPress and espresso equipment, a phone showing a brew timer, and bags of Wonderbean coffee."
          className="w-full h-full object-cover"
        />
      </div>

      <p className="mt-6 text-base leading-relaxed text-[#1F2A44]/90" data-testid="home-description">
        {content.description}
      </p>
      <p className="mt-4 text-base leading-relaxed text-[#1F2A44] font-medium" data-testid="home-closing">
        {content.closing}
      </p>

    </div>
  );
}
